module.exports = __webpack_public_path__ + "assets/img/gif-2.e7001b0b.jpg";